<template>
  <div class="logList">
    <FORM ref="childForm" @formclick="formclick" :formData="formData"></FORM>
    <table-page ref="childTable" @btnclick="btnclick" :pageData="pageData"></table-page>
    <UPDATE ref="childUpdate" @uploadSuc="loadLogList" @submit="submit" :updateData="updateData"></UPDATE>
  </div>
</template>

<script>
import Qs from 'qs'
import Url from '@/views/analyse/util/url'
import FORM from '@/components/page/form'
import tablePage from '@/components/page/table'
import UPDATE from '@/components/page/update'
import DataUtil from '@/utils/dataUtil'

//发送类型
const sendTypeList = [
  {key:0, value:"自动发送"},
  {key:1, value:"通知短信"},
  {key:2, value:"营销短信"},
  {key:3, value:"手机号短信"},
]

//发送结果
const sendResultList = [
  {key:0, value:"未发送"},
  {key:1, value:"成功"},
  {key:2, value:"失败"},
]

export default {
  name: 'logList',
  components: {
    FORM,
    tablePage,
    UPDATE
  },
  data() {
    return {
      queryData: {},
      /*form查询表单*/
      formData: {
        hasLable: true,
        cols: []
      },
      /*table查询记录*/
      pageData: {
        queryUrl: Url.sms.logList,
        selection: false,
        sequence: false,
        method: 'get',
        cols: [
          { title: '发送类型', field: 'sendType', width: '100px', render: (data, full) => {return sendTypeList.find(e => e.key === data).value} },
          { title: '客戶帐号', field: 'customerNumber' },
          { title: '客戶手机号', field: 'mobilePhone' },
          { title: '发送内容', field: 'sendContent' },
          { title: '发送时间', field: 'sendTime', width: '150px', render: (data, full) => {return DataUtil.formatDate(data, 'yyyy-MM-dd hh:mm:ss')} },
          { title: '发送结果', field: 'sendResult', width: '100px', render: (data, full) => {return sendResultList.find(e => e.key === data).value} },
          { title: '失败原因', field: 'failReason' },
          { title: '创建时间', field: 'createTime', width: '150px', render: (data, full) => {return DataUtil.formatDate(data, 'yyyy-MM-dd hh:mm:ss')} },
        ]
      },
      /*add或update浮窗表单*/
      updateData: {
        modelName: '批量发送',
        cols: []
      },
    }
  },
  methods: {
    dataChange(url, option, suc, fail) {
      this.$axios.post(url, Qs.stringify(option || {})).then(res => {
        if (suc && (typeof suc == 'function')) suc(res)
      }).catch(res => {
        if (fail && (typeof fail == 'function')) fail(res)
      })
    },

    /*form按钮点击事件*/
    formclick(clickName, data) {
      if (clickName == window.$t('common.search')) {
        data.status = 1
        data.sendTimeStart = data.sendTimeStart ? new Date(data.sendTimeStart).getTime() : ''
        data.sendTimeEnd = data.sendTimeEnd ? new Date(data.sendTimeEnd).getTime() : ''
        this.queryData = data
        this.$refs.childTable.defaultQueryData(data)

      } else if (clickName == window.$t('sms.batchSend')) {
        this.$refs.childUpdate.open()
      }
    },

    /*table按钮点击事件*/
    btnclick(clickName, row) {
//      if (clickName == window.$t('common.edit')) {
//        this.$refs.childUpdate.open(row)
//      }
    },

    /*add或update提交数据触发事件*/
    submit(model) {
      this.dataChange(Url.sms.logBatchSave, model, res => {
        if (res.code == 0) {
          this.$refs.childUpdate.close()
          this.$message.success('操作成功')
          this.$refs.childTable.defaultQueryData(this.queryData)
        } else {
          this.$message.error(res.message)
        }
      })
    },

    /*其它*/
//    checkbox(row) {
//      this.selectData.ids = row.map(key => key.id).join(",");
//    },
    loadLogList(col, result, cols) {
      for (let i in cols) {
        if (cols[i].field == 'logList') {
          let newCol = JSON.parse(JSON.stringify(cols[i]))
          if (result != null) {
            newCol.data = result
          } else {
            newCol.data = ""
          }
          cols.splice(i, 1, newCol)
        } else if (cols[i].field == 'logCount') {
          let newCol = JSON.parse(JSON.stringify(cols[i]))
          if (result != null) {
            newCol.data = JSON.parse(result).length
          } else {
            newCol.data = "0"
          }
          cols.splice(i, 1, newCol)
        }
      }
    },
  },
  created() {
    /*表单初始化*/
    this.formData.cols = [
      { title: '发送类型', field: 'sendType', type: 2, optionList: sendTypeList },
      { title: '客户账号', field: 'customerNumber' },
      { title: '客户手机号', field: 'mobilePhone' },
      { title: '发送内容', field: 'sendContent' },
      { title: '发送时间', field: 'time', type: 6, format: 'yyyy-MM-dd HH:mm:ss', startEndParam: ['sendTimeStart', 'sendTimeEnd'] },
      { title: '发送结果', field: 'sendResult', type: 2, optionList: sendResultList },
      { click: window.$t('common.search'), icon: 'el-icon-search' },
      { click: window.$t('sms.batchSend'), icon: 'el-icon-upload' },
    ]
    this.updateData.cols = [
//      { title: '序号', field: 'id', hidden: true },
      { title: '发送类型', field: 'sendType', type: 2, optionList: sendTypeList, required: true },
      { title: '汇入发送列表', field: 'file', type: 11, action: Url.sms.logExtract, showFileName: false, downUrl: 'https://img.cfd139.com/source/downModel/批量发送短信.xlsx' },
      { title: '发送列表', field: 'logList', textType: 'textarea', readonly: true, required: true },
      { title: '数量', field: 'logCount', type: 17 },
    ]
  }

}
</script>
